export const FETCH_CONSTRAINTS = "FETCH_CONSTRAINTS";
export const FETCH_CONSTRAINTS_PENDING = "FETCH_CONSTRAINTS_PENDING";
export const FETCH_CONSTRAINTS_REJECTED = "FETCH_CONSTRAINTS_REJECTED";
export const FETCH_CONSTRAINTS_FULFILLED = "FETCH_CONSTRAINTS_FULFILLED";
